import React, { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Box, Typography } from '@mui/material';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { selectTeamChatTypingUsers } from 'store/teamChat/selectors';

import { getMemberId, getMemberNickname } from '../TeamChat.utils';

import { rootStyles } from './TeamChatTypingIndicator.styles';
import { getTypingLabel, resolveTypingMemberNickname } from './TeamChatTypingIndicator.utils';

const TeamChatTypingIndicator = memo(({ chatId, currentUserId = null, members = [] }) => {
  const typingUsers = useSelector(selectTeamChatTypingUsers(chatId));

  const nicknamesById = useMemo(
    () => _.mapValues(_.keyBy(members, getMemberId), getMemberNickname),
    [members],
  );

  const nicknames = useMemo(
    () =>
      _.compact(
        _.map(typingUsers, info =>
          resolveTypingMemberNickname({
            memberId: info?.memberId,
            nicknamesById,
            currentUserId,
          }),
        ),
      ),
    [typingUsers, nicknamesById, currentUserId],
  );

  const label = getTypingLabel(nicknames);

  if (!label) {
    return null;
  }

  return (
    <Box sx={rootStyles}>
      <Typography color="text.secondary" variant="regular12">
        {label}
      </Typography>
    </Box>
  );
});
TeamChatTypingIndicator.propTypes = {
  chatId: PropTypes.string,
  currentUserId: PropTypes.string,
  members: PropTypes.arrayOf(PropTypes.object),
};

export default TeamChatTypingIndicator;
